/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TheCargo Shipment
 * Core logistics engine for managing vehicle shipments from lead intake to final delivery.

## Shipment Lifecycle

Every shipment progresses through three stages:

| Stage | Description |
|-------|-------------|
| `lead` | Initial inquiry — vehicle and route info collected |
| `quote` | Price quoted to the customer |
| `order` | Confirmed order dispatched to a carrier |

Use `POST /api/v1/shipments/{id}/convert` to advance a shipment between stages.

## Authentication

All endpoints require a JWT Bearer token:
```
Authorization: Bearer <access_token>
```

Obtain tokens via the **Auth Service** (`POST /auth/api/v1/auth/login`).

## Contact

For API access or issues contact **support@thecargo.io**
 * OpenAPI spec version: 1.0.0
 */

/**
 * Server-computed lifecycle state. Frontend should read this rather than recomputing from the timestamp columns — order-of-precedence rules live on :class:`CarrierRequest.status` so they stay consistent everywhere.
 */
export type CarrierRequestListItemStatus =
  (typeof CarrierRequestListItemStatus)[keyof typeof CarrierRequestListItemStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CarrierRequestListItemStatus = {
  pending: 'pending',
  counter_sent: 'counter_sent',
  offer_sent: 'offer_sent',
  accepted: 'accepted',
  declined: 'declined',
  withdrawn: 'withdrawn',
  canceled: 'canceled',
} as const
